function SwirlArrowBottomLeft() {
  return (
    <svg viewBox="0 0 512 442.136">
      <path
        fill="currentColor"
        d="M13.465 442.136c31.386-25.228 67.041-47.435 83.064-62.714 5.281-5.036 11.006-12.153 1.663-8.574-25.872 9.91-54.003 27.668-75.003 49.745 2.547-18.499-2.366-41.616-9.997-60.505-.938-2.328-3.886-11.918-7.546-15.088-1.359-1.177-2.82-1.473-4.308-.18-.849.738-1.279 1.995-1.333 3.707-.152 4.982 3.388 19.557 6.693 33.834 4.905 21.183 7.422 37.783 6.767 59.775z"
      />
      <path
        fill="currentColor"
        d="M268.172 236.348c-4.322-22.157-5.797-44.278-4.95-66.742-45.792 16.982-86.744 47.758-120.988 82.094-41.377 41.487-75.893 91.78-100.677 142.433-7.709 15.756-12.142 22.106-22.78 36.216 19.82-95.783 137.212-251.197 246.697-274.194C279.782 29.162 408.945-53.716 512 40.704c-95.354-64.986-210.522-25.748-234.658 113.479 11.685-1.413 23.233-1.218 34.515.824 26.693 4.831 52.462 12.783 72.736 38.719 28.125 35.979 26.324 94.976-19.286 115.588-54.862 24.792-87.927-25.74-97.135-72.966zm7.016-67.488c-.889 23.576 1.128 48.171 6.111 71.196 8.03 37.107 29.726 69.192 65.407 62.821 22.084-3.944 35.695-18.675 40.56-38.117 17.522-70.029-62.617-107.875-112.078-95.9z"
      />
    </svg>
  );
}

export default SwirlArrowBottomLeft;
